var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "30px",
    viewBox: "0 0 23 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-On-the-ground-Videos",
    transform: "translate(-551.000000, -323.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(123.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hot-Topic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(283.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.834286,68.411415 L122.12,54.1257007 C121.900714,53.9749864 121.616429,53.9592722 121.382143,54.081415 C121.147143,54.2049864 121,54.4478436 121,54.7135579 L121,83.2849864 C121,83.5507007 121.147143,83.7942722 121.382143,83.9178436 C121.486429,83.9721293 121.600714,83.9992722 121.714286,83.9992722 C121.856429,83.9992722 121.997857,83.956415 122.12,83.8728436 L142.834286,69.5871293 C143.027857,69.4535579 143.142857,69.2342722 143.142857,68.9992722 C143.142857,68.7642722 143.027143,68.5449864 142.834286,68.411415 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayWhite);
export default __webpack_public_path__ + "static/media/icPlayWhite.dd14fd8bc877cfcb89443ea54c381ac6.svg";
export { ForwardRef as ReactComponent };